<script setup lang="ts">
import type { AccordionData } from 'types/accordion';
import type { ComponentStyles } from 'types';

defineProps<{
  data: AccordionData;
  componentStyles: ComponentStyles;
}>();
</script>

<template>
  <BaseComponentWrapper :component-styles="componentStyles">
    <div class="2xl:narrow-container container">
      <div v-if="data.headline || data.description">
        <h2
          v-if="data.headline"
          class="mb-4 md:mb-6"
        >
          {{ data.headline }}
        </h2>
        <p
          v-if="data.description"
          class="mb-4"
        >
          {{ data.description }}
        </p>
      </div>

      <PartialsAccordion
        :accordion-items="data.accordionItems"
        :allow-multiple="data.allowMultiple"
      />
    </div>
  </BaseComponentWrapper>
</template>
